module.exports = __webpack_public_path__ + "img/23.4.NH3-N.f6a4419d.png";